import { useParams } from 'react-router-dom';
import { BookParams } from '@monorepo/shared/src/types';
import { BookType } from '../graph/schema-generated-types-educator';

const useBookParams = (): BookParams => {
  const { bookCode, letter } = useParams();

  if (bookCode) return { bookCode };

  const bookType = (letter ? BookType.LETTER_BOOK : BookType.CLASSROOM_BOOK) as any;

  return { letter, bookType };
};

export default useBookParams;
